export default "__VITE_ASSET__20091e47__"